import { makeStyles, Theme } from '@material-ui/core';
import React from 'react';

interface ProfileCardContentProps {
  children?: React.ReactNode;
  className?: string;
  dataTestId?: string;
  disablePadding?: boolean;
}

export default function ProfileCardContent({
  children,
  className = '',
  dataTestId,
  disablePadding,
}: ProfileCardContentProps) {
  const classes = useStyles();
  const rootClass = disablePadding
    ? `${classes.root} ${className}`
    : `${classes.root} ${classes.rootPadded} ${className}`;

  return (
    <div className={rootClass} data-testid={dataTestId}>
      {children}
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    color: theme.palette.text.primary,
    fontFamily: 'Avenir, Arial, Verdana, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  rootPadded: {
    padding: '16px 24px',
  },
}));
